
(function() {
  function formatMoney(cents) {
    try {
      cents = parseInt(cents,10);
      return (cents/100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    } catch(e) {
      return (cents/100).toFixed(2);
    }
  }

  function openModal() {
    var m = document.getElementById('cart-add-modal');
    if (!m) return;
    m.style.display = 'block';
    document.documentElement.classList.add('cart-add-modal-open');
  }
  function closeModal() {
    var m = document.getElementById('cart-add-modal');
    if (!m) return;
    m.style.display = 'none';
    document.documentElement.classList.remove('cart-add-modal-open');
  }

  function populate(lineItem, cart) {
    var m = document.getElementById('cart-add-modal');
    if (!m) return;
    var img = m.querySelector('.cart-add-image img');
    var title = m.querySelector('.cart-add-title');
    var price = m.querySelector('.cart-add-price');
    var sku = m.querySelector('.cart-add-sku');
    var qty = m.querySelector('.cart-add-qty');
    var subtotal = m.querySelector('.cart-add-subtotal-value');

    if (img) img.src = (lineItem && lineItem.image) || (lineItem && lineItem.featured_image && lineItem.featured_image.url) || '';
    if (img) img.alt = lineItem && (lineItem.product_title || lineItem.title) || '';
    if (title) title.textContent = lineItem && (lineItem.product_title || lineItem.title) || '';
    if (price) price.textContent = formatMoney((lineItem && lineItem.price) || 0);
    if (sku) sku.textContent = (lineItem && lineItem.sku) ? ('Part Number: ' + lineItem.sku) : '';
    if (qty) qty.textContent = 'Qty. ' + ((lineItem && lineItem.quantity) || 1);
    if (subtotal) subtotal.textContent = cart ? formatMoney(cart.total_price) : '';
  }

  function updateHeaderCount(cart){
    try {
      var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
      var selectors = ['.mini-cart-icon .bigcounter', '.cart-count', '.cart__count', '#CartCount', '.header-cart-count'];
      selectors.forEach(function(sel){
        var el = document.querySelector(sel);
        if (el){ el.textContent = count; }
      });
      var countBadges = document.querySelectorAll(selectors.join(','));
      countBadges.forEach(function(el){
        if (count > 0) { el.classList.remove('hidden'); el.parentElement && el.parentElement.classList.remove('hide'); }
        else { el.classList.add('hidden'); }
      });
    } catch(e){}
  }

  function updateHeaderTotal(cart){
    try {
      var totalCents = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      var formatted = formatMoney(totalCents);
      var updated = false;
      var directSelectors = ['.mini-cart-icon-2 .shopping-cart__total', '.mini-cart-icon-2 .ltn__secondary-color', '.header-cart-total', '#CartTotal'];
      directSelectors.forEach(function(sel){
        var el = document.querySelector(sel);
        if (el){ el.textContent = formatted; updated = true; }
      });
      if (!updated) {
        var h6 = document.querySelector('.mini-cart-icon-2 h6');
        if (h6){
          var spans = h6.querySelectorAll('span');
          if (spans.length){
            var target = spans[spans.length - 1];
            var deep = target.querySelector('span');
            if (deep) target = deep;
            target.textContent = formatted;
          }
        }
      }
    } catch(e){}
  }

  function refreshMiniCart(){ 
    try {
      fetch('/cart?view=mini', {headers:{'Accept':'text/html'}})
        .then(function(r){ return r.text(); })
        .then(function(html){
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#ltn__utilize-cart-menu');
          var current = document.querySelector('#ltn__utilize-cart-menu');
          if (fresh && current){
            current.replaceWith(fresh);
          }
        });
    } catch(e){}
  }

  // Recently viewed (optional hooks are no-ops if not present)
  function getRecentlyViewed() {
    try {
      var raw = localStorage.getItem('rv_products') || '[]';
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) arr = [];
      var seen = {}, out = [];
      var limit = (document.querySelector('.cart-add-dialog') && parseInt(document.querySelector('.cart-add-dialog').getAttribute('data-recent-limit'),10)) || 8;
      for (var i=arr.length-1;i>=0 && out.length<limit;i--) {
        var h = arr[i];
        if (!h || seen[h]) continue;
        seen[h] = 1; out.push(h);
      }
      return out;
    } catch(e) { return []; }
  }
  function loadRecentlyViewed() {
    var wrapper = document.querySelector('[data-recently-viewed-wrapper]');
    var grid = document.querySelector('[data-recent-grid]');
    if (!wrapper || !grid) return;
    var handles = getRecentlyViewed();
    if (!handles.length) { wrapper.style.display = 'none'; return; }
    wrapper.style.display = '';
    grid.innerHTML = '';
    handles.forEach(function(handle){
      fetch('/products/' + handle + '?view=card-mini', {headers:{'Accept':'text/html'}})
        .then(function(r){return r.text();})
        .then(function(html){
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var card = tmp.querySelector('a.cart-add-recent-card');
          if (card) grid.appendChild(card);
        });
    });
  }

  function init(){
    // Close handlers
    document.addEventListener('click', function(e){
      if (e.target && e.target.matches('[data-cart-add-close]')){
        e.preventDefault();
        closeModal();
        return false;
      }
    }, true);

    // Remember which button triggered submit to detect BUY NOW
    document.addEventListener('click', function(ev){
      var btn = ev.target.closest('button, input[type="submit"]');
      if (!btn) return;
      var form = btn.form || btn.closest('form');
      if (!form) return;
      var txt = (btn.value || btn.textContent || '').trim().toLowerCase();
      if (btn.classList.contains('buy-now') || btn.dataset.action === 'buy-now' || txt === 'buy now' || txt === 'buynow') {
        try { form.setAttribute('data-buy-now','1'); } catch(_){}
      }
    }, true);

    // Capture-phase submit interceptor
    var intercept = function(e){
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action')||'').toLowerCase();
      var isAddForm = /\/cart\/add(\.js)?/.test(action) || (form.querySelector('input[name="id"]') && !form.querySelector('input[name="form_type"]'));
      if (!isAddForm) return;
      var isBuyNow = form.hasAttribute('data-buy-now') || (form.querySelector('input[name="return_to"][value^="/checkout"]') != null);

      try { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); } catch(_){}
      if (!/\/cart\/add\.js/.test(action)) { form.setAttribute('action','/cart/add.js'); }

      
      // BUY NOW: clear cart, add this item only, then go straight to checkout
      if (isBuyNow) {
        try {
          var fd = new FormData(form);
          // ensure quantity present
          if (!fd.get('quantity')) { fd.set('quantity', '1'); }
          return fetch('/cart/clear.js', {method:'POST'})
            .then(function(){ return fetch('/cart/add.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} }); })
            .then(function(){ window.location.href = '/checkout'; });
        } catch(_){
          window.location.href = '/checkout';
        }
        return false;
      }
if (window.ShopifyAPI && typeof ShopifyAPI.addItemFromForm === 'function') {
        ShopifyAPI.addItemFromForm(form, function(line_item){
          if (isBuyNow) { window.location.href = '/checkout'; return; }
          ShopifyAPI.getCart(function(cart){
            populate(line_item, cart);
            updateHeaderCount(cart);
            updateHeaderTotal(cart);
            refreshMiniCart();
            loadRecentlyViewed();
            openModal();
          });
        }, function() {
          ShopifyAPI.getCart(function(cart){
            if (isBuyNow) { window.location.href = '/checkout'; return; }
            populate({}, cart);
            updateHeaderCount(cart);
            updateHeaderTotal(cart);
            refreshMiniCart();
            loadRecentlyViewed();
            openModal();
          });
        });
      } else {
        var fd = new FormData(form);
        fetch('/cart/add.js', { method:'POST', body:fd, headers:{'Accept':'application/json'} })
          .then(function(r){ return r.json(); })
          .then(function(line_item){
            return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
              if (isBuyNow) { window.location.href = '/checkout'; return; }
              populate(line_item, cart);
              updateHeaderCount(cart);
              updateHeaderTotal(cart);
              refreshMiniCart();
              loadRecentlyViewed();
              openModal();
            });
          });
      }
      return false;
    };

    document.addEventListener('submit', intercept, true);

    // Also bind directly to existing forms and their submit buttons (capture)
    try {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
        try {
          f.noValidate = true;
          if (!/\/cart\/add\.js/.test((f.getAttribute('action')||'').toLowerCase())) {
            f.setAttribute('action','/cart/add.js');
          }
          f.addEventListener('submit', intercept, true);
        } catch(e){}
      });
    } catch(e){}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, true);
  } else {
    init();
  }
})();
